import React, { Fragment, useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import Table from "@material-ui/core/Table";
import { Box, TextField } from "@mui/material";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FormLabel from "@material-ui/core/FormLabel";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles({
	table: {
		minWidth: 250,
	},
	inputStyles: {
		width: "100%",
	},
});

const ChangeTypeTable = (props) => {
	const {
		rows,
		updateRows,
		changeTypeOptions,
		otherTypeText,
		updateOtherTypeText,
		amendmentType,
		isReadOnly,
	} = props;

	const classes = useStyles();

	const updateCurrentRow = (row, index) => {
		if (index == 0) {
			//Term Modification
			row.currentValue = row.currentValue.replace(/\D/g, ""); //Allow numbers
			row.changedTo = row.changedTo.replace(/\D/g, ""); //Allow numbers
		} else if (index == 1) {
			//VIN/Serial Update
			row.currentValue = row.currentValue.replace(/[^a-zA-Z0-9]/g, ""); //Allow numbers & letters
			row.changedTo = row.changedTo.replace(/[^a-zA-Z0-9]/g, ""); //Allow numbers & letters
		} else if (index == 2) {
			//Equipment Description
			row.currentValue = row.currentValue.replace(/[^a-zA-Z0-9\s]/g, ""); //Allow numbers, letters & spaces
			row.changedTo = row.changedTo.replace(/[^a-zA-Z0-9\s]/g, ""); //Allow numbers, letters & spaces
		} else if (index == 3) {
			//Debtor Name
			row.currentValue = row.currentValue.replace(
				/[^a-zA-Z0-9!@#$%^&*()\-_=+[\]{};:'"\\|,.<>/?~`\s]/g,
				""
			); //Allow numbers, letters & spaces
			row.changedTo = row.changedTo.replace(
				/[^a-zA-Z0-9!@#$%^&*()\-_=+[\]{};:'"\\|,.<>/?~`\s]/g,
				""
			); //Allow numbers, letters & spaces
		} else if (index == 4) {
			//Equipment Location
			row.currentValue = row.currentValue.replace(
				/[^a-zA-Z0-9!@#$%^&*()\-_=+[\]{};:'"\\|,.<>/?~`]/g,
				""
			); //Allow numbers, letters & special characters
			row.changedTo = row.changedTo.replace(
				/[^a-zA-Z0-9!@#$%^&*()\-_=+[\]{};:'"\\|,.<>/?~`]/g,
				""
			); //Allow numbers, letters & special characters
		} else if (index == 5) {
			//Payment Amounts
			row.currentValue = row.currentValue.replace(/[^0-9$,.]/g, "");//Allow numbers & {$ , .}
			row.changedTo = row.changedTo.replace(/[^0-9$,.]/g, ""); //Allow numbers & {$ , .}
		} else if (index == 6) {
			//Payment Frequency
			row.currentValue = row.currentValue.replace(/\D/g, ""); //Allow numbers
			row.changedTo = row.changedTo.replace(/\D/g, ""); //Allow numbers
		} else if (index == 7) {
			//Security Deposit
			row.currentValue = row.currentValue.replace(/[^0-9$,.]/g, ""); //Allow numbers & {$ , .}
			row.changedTo = row.changedTo.replace(/[^0-9$,.]/g, ""); //Allow numbers & {$ , .}
		} else if (index == 8) {
			//Equipment Cost
			row.currentValue = row.currentValue.replace(/[^0-9$,.]/g, ""); //Allow numbers & {$ , .}
			row.changedTo = row.changedTo.replace(/[^0-9$,.]/g, ""); //Allow numbers & {$ , .}
		}

		const newRows = rows.map((currentRow) => {
			return currentRow.changeType === row.changeType ? row : currentRow;
		});
		updateRows(newRows);
	};

	return (
		<>
			{amendmentType !== "New Docs" ? (
				<>
					<Box mt={3} mb={2}>
						<FormLabel component="legend">Changes</FormLabel>
					</Box>
					<TableContainer component={Paper}>
						<Table
							className={classes.table}
							// padding="none"
							size="small"
							aria-label="a dense table">
							<TableHead>
								<TableRow>
									<TableCell style={{ width: "35%" }}></TableCell>
									<TableCell style={{ width: "32%" }}>Current Value</TableCell>
									<TableCell style={{ width: "20px", padding: 0 }}>
										<ArrowRightIcon />
									</TableCell>
									<TableCell style={{ width: "32%" }}>Changed To</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{rows.map((row, index) => {
									return (
										<TableRow key={row.changeType}>
											<TableCell component="th" scope="row">
												{row.changeType}
											</TableCell>
											<TableCell>
												<input
													disabled={isReadOnly}
													className={classes.inputStyles}
													value={row.currentValue}
													onChange={(e) => {
														updateCurrentRow(
															{
																...row,
																currentValue: e.target.value,
															},
															index
														);
													}}
												/>
											</TableCell>
											<TableCell style={{ padding: 0 }} />
											<TableCell>
												<input
													disabled={isReadOnly}
													className={classes.inputStyles}
													value={row.changedTo}
													onChange={(e) => {
														updateCurrentRow(
															{
																...row,
																changedTo: e.target.value,
															},
															index
														);
													}}
												/>
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
					<Box mt={3}>
						<Box mb={2}>
							<FormLabel component="legend">Other</FormLabel>
						</Box>
						<TextField
							disabled={isReadOnly}
							sx={{ width: "100%" }}
							value={otherTypeText}
							onChange={(e) => updateOtherTypeText(e.target.value)}
							type="text"
							multiline={true}
							minRows={4}
						/>
					</Box>
				</>
			) : (
				<Box></Box>
			)}
		</>
	);
};

export default ChangeTypeTable;
